import { render, staticRenderFns } from "./RoomCreate.vue?vue&type=template&id=2e456499&scoped=true&"
import script from "./RoomCreate.vue?vue&type=script&lang=js&"
export * from "./RoomCreate.vue?vue&type=script&lang=js&"
import style0 from "./RoomCreate.vue?vue&type=style&index=0&id=2e456499&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e456499",
  null
  
)

export default component.exports